<template>
  <div class="ui left aligned container">
    <div class="ui right aligned container">
      <button @click="refresh()" class="ui primary mini button" id="refresh"><i class="sync icon"></i></button>
    </div>
    <vuetable ref="vuetable"
              api-url="/celebrity"
              :fields="fields"
              @vuetable:load-success="dataLoaded($event)"
    >
    </vuetable>
    <br>
    <div v-if="time">统计时间：{{time}}</div>
  </div>
</template>
<style>
</style>
<script>
  import Vuetable from '../table/Vuetable.vue'

  export default {
    name: 'CelebrityList',
    components: {
      Vuetable,
    },
    data () {
      return {
        time: '',
        fields: [
          {name: 'name', title: '姓名', callback: 'link'},
          {name: 'popularValue', title: '人气值'},
          {name: 'rank', title: '排名'},
          {name: 'rankStatus', title: '#', callback: 'rankStatus'},
        ]
      }
    },
    methods: {
      dataLoaded: function (event) {
        this.time = new Date(event.data.time).toLocaleString();
      },
      refresh: function () {
        this.$refs.vuetable.reload();
      },
      link: function (value, item) {
        return '<a href="https://m.maoyan.com/assist/celebrity/' + item.celebrityId + '?_v_=yes" target="_blank">' + value + '</a>';
      },
      rankStatus: function (value) {
        if (value > 0) {
          return '↑';
        }
        if (value < 0) {
          return '↓';
        }
        return '-';
      }
    }
  }
</script>
